module.exports = __webpack_public_path__ + "static/media/34_bsp.06afbd69.mp3";